import { useState } from 'react';
import { NavLink as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Box, Button, Collapse, ListItem, Typography, Stack } from '@mui/material';
import ChevronDownIcon from '../icons/ChevronDown';
import ChevronRightIcon from '../icons/ChevronRight';
import Badge from '@mui/material/Badge';
import { useTheme } from '@mui/material/styles';
import useParametros from '../hooks/useParameters';

const sortList = (list) => {
  return list.sort((a, b) => new Date(b.date) - new Date(a.date));
};
function NavItem(props) {
  const { active, children, depth, icon, info, open: openProp, path, title, badge, ...other } = props;
  const [open, setOpen] = useState(openProp);
  const { changelog } = useParametros();
  const changelogDateSort = sortList(changelog ?? []);
  const lastSeenUpgrade = localStorage.getItem('badgeVisible');
  const theme = useTheme();

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  let paddingLeft = 16;

  if (depth > 0) {
    paddingLeft = 32 + 8 * depth;
  }

  // Branch
  if (children) {
    return (
      <ListItem disableGutters sx={{ display: 'block', py: 0 }} {...other}>
        <Button
          endIcon={!open ? <ChevronRightIcon fontSize="small" /> : <ChevronDownIcon fontSize="small" />}
          onClick={handleToggle}
          startIcon={icon}
          sx={{
            fontSize: '1rem', // no estaba change
            color: 'text.secondary',
            fontWeight: 'fontWeightMedium',
            // fontWeight: 400,
            justifyContent: 'flex-start',
            pl: `${paddingLeft}px`,
            pr: '8px',
            py: '8px', // era 12 change
            textAlign: 'left',
            textTransform: 'none',
            width: '100%',
          }}
          variant="text"
        >
          <Box sx={{ flexGrow: 1 }}>
            {(badge || title === 'Novedades') ? (
              <Badge
                variant="dot"
                invisible={lastSeenUpgrade === changelogDateSort[0].date}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                sx={{ '& .MuiBadge-badge': { backgroundColor: theme.palette.error.main, right: -10, top: 6 } }}
              >
                {title}
              </Badge>
            ) : (
              title
            )}
          </Box>
          {info}
        </Button>
        <Collapse in={open}>{children}</Collapse>
      </ListItem>
    );
  }

  // Leaf
  return (
    <ListItem disableGutters sx={{ display: 'flex', py: 0 }}>
      <Button
        component={path && RouterLink}
        startIcon={icon}
        sx={{
          fontSize: '1rem', // no estaba change
          color: 'text.secondary',
          fontWeight: 'fontWeightMedium',
          justifyContent: 'flex-start',
          textAlign: 'left',
          pl: `${paddingLeft}px`,
          pr: '8px',
          py: '8px', // era 12 change
          textTransform: 'none',
          width: '100%',
          ...(active && { color: 'primary2.main', fontWeight: 'fontWeightBold', '& svg': { color: 'primary2.main' } }),
        }}
        variant="text"
        to={path}
      >
        <Box sx={{ flexGrow: 1 }}>
          <Stack direction="row" alignItems="center">
            <Typography variant="subtitle1">
              {(badge || title === 'Novedades') ? (
                <Badge
                  variant="dot"
                  invisible={lastSeenUpgrade === changelogDateSort[0].date}
                  anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                  sx={{ '& .MuiBadge-badge': { backgroundColor: theme.palette.error.main, right: -10, top: 6 } }}
                >
                  {`> ${title}`}
                </Badge>
              ) : (
                `> ${title}`
              )}
            </Typography>
          </Stack>
        </Box>
        {info}
      </Button>
    </ListItem>
  );
}

NavItem.propTypes = {
  active: PropTypes.bool,
  children: PropTypes.node,
  depth: PropTypes.number.isRequired,
  icon: PropTypes.node,
  info: PropTypes.node,
  open: PropTypes.bool,
  path: PropTypes.string,
  title: PropTypes.string.isRequired,
};

NavItem.defaultProps = { active: false, open: false };

export default NavItem;
